import React, { Component } from 'react';
import LoadedContent from './LoadedContent';
import { CSSTransitionGroup } from 'react-transition-group';
import { isMobile } from '../../tools/mobileCheck';
import ProjectListContainer from './ProjectList';
import TextScramble from './TextScramble';
import { I18n } from 'react-redux-i18n';

class HomePage extends Component {
  render() {
    const title = I18n.t('home_page.title');
    const subtitle = I18n.t('home_page.subtitle');

    return (
      <LoadedContent noBack>
        <CSSTransitionGroup
          component="div"
          id="home-page-wrapper"
          transitionName="pageFadeInUp"
          transitionEnter={false}
          transitionLeave={false}
          transitionAppear={true}
          transitionAppearTimeout={500}
        >
          <div id="home-page">
            <div /> {/* invisible flex item, used to center title vertically*/}
            <div className="page-title">
              <div className="highlight">
                <TextScramble texts={title} />
              </div>
              <TextScramble texts={[subtitle]} />
            </div>
            {isMobile() ? (
              <ProjectListContainer />
            ) : (
              <div>
                <div>∞</div>
                <div>ferreri.co</div>
              </div>
            )}
          </div>
        </CSSTransitionGroup>
      </LoadedContent>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/HomePage.js